'use client';

// 應用層 root error boundary
// React render 階段的錯誤會冒泡到這裡（一般 error.tsx 抓不到 layout.tsx 的錯）
// 這層 Sentry.captureException 才能讓 client React 錯誤進到 Sentry

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="zh-Hant">
      <body style={{ fontFamily: 'system-ui, sans-serif', padding: '2rem', color: '#3f3a36' }}>
        <h2 style={{ marginBottom: '1rem' }}>發生未預期錯誤</h2>
        <p>系統已記錄此問題，請稍後再試，或回到首頁。</p>
        <p style={{ marginTop: '1rem' }}>
          {/* global-error 取代整個 <html>，next/link 在這層不安全；用原生 <a> */}
          {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
          <a href="/" style={{ color: '#5b7a4f', textDecoration: 'underline' }}>回到首頁</a>
        </p>
      </body>
    </html>
  );
}
